import Loading from '../../../Common/Loading';
import { useVehiclesChartsDataContext } from './hooks/useVehiclesChartsDataContext';
import { BrandAnualList } from './BrandAnualList';
import { BrandMonthList } from './BrandMonthList';
import { TypeAnualList } from './TypeAnualList';
import { TypeMonthList } from './TypeMonthList';
import { YearAnualList } from './YearAnualList';
import { YearMonthList } from './YearMonthList';
import { ColorAnualList } from './ColorAnualList';
import { ColorMonthList } from './ColorMonthList';

export const Charts = () => {
    const { isLoading } = useVehiclesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <BrandAnualList />
                <BrandMonthList />
            </div>
            <div className="charts-side-by-side-dashboards">    
                <TypeAnualList />
                <TypeMonthList />
            </div>
            <div className="charts-side-by-side-dashboards">
                <YearAnualList />
                <YearMonthList />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ColorAnualList />
                <ColorMonthList />
            </div>
        </>
    );
};
